import React, { Component } from "react";
// import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { BarLoader } from "react-spinners";
import axios from "axios";
// import { ReactReduxContext } from "react-redux";

class LiveMonitoringDatatable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      liveMonitoringData: [],
      location: "",
    };
  }

  componentDidMount() {
    if (this.state.liveMonitoringData.length > 0) {
      const { lat, lng } = this.state.liveMonitoringData[0]; // Misalnya, ambil data pertama
      this.getGeocoding(lat, lng);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.liveMonitoringData !== this.props.liveMonitoringData) {
      this.setState({
        liveMonitoringData: this.props.liveMonitoringData,
      });

      if (this.props.liveMonitoringData.length > 0) {
        const { lat, lng } = this.props.liveMonitoringData[0];
        this.getGeocoding(lat, lng);
      }
    }
  }

  clickableIdFleet = (data) => {
    return (
      <div
        style={{ cursor: "pointer", color: "#1a4e8e" }}
        onClick={() => this.onIdFleetClicked(data)}
      >
        <strong>{`${data.reg_number} ${
          data.door_number ? `(${data.door_number})` : ""
        }`}</strong>
      </div>
    );
  };

  onIdFleetClicked = (data) => {
    this.props.onIdFleetClicked(data);
  };

  latDataFormat = (data) => {
    if (data.lat === null || data.lng === null) {
      return <span>-</span>;
    } else {
      return (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => this.onPositionClicked(data.lat, data.lng)}
        >
          <strong style={{ color: "#1a4e8e" }}>
            {data.lat} , {data.lng}
          </strong>
        </div>
      );
    }
  };

  onPositionClicked = (lat, lng) => {
    window.open(`https://www.google.com/maps?q=loc:@${lat},${lng}`, "_blank");
  };

  getGeocoding = async (lat, lng) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCmIATqobqbCEU90nYtwd-PzCcj8EVOlDg&v=3.exp`
      );

      const result = response.data;
      if (result.status === "OK") {
        this.setState({ location: result.results[0].formatted_address });
      } else {
        this.setState({ location: "Location not found" });
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  fleetStatusFormat = (data) => {
    if (data.wrn === 0) {
      return (
        <span>
          Off <i className="fas fa-truck" style={{ color: "grey" }}></i>
        </span>
      );
    }
    return data.spd > 3.5 ? (
      <span>
        On & Moving <i className="fas fa-truck" style={{ color: "green" }}></i>
      </span>
    ) : (
      <span>
        On & Idle <i className="fas fa-truck" style={{ color: "blue" }}></i>
      </span>
    );
  };

  doorStatus = (data) => {
    if (data === undefined || data === null) {
      return <span>-</span>;
    }
    return data > 0 ? <span>Open</span> : <span>Close</span>;
  };

  tempStatus = (data) => {
    if (data === undefined || data === null) {
      return <span>-</span>;
    }
    return (
      <span>
        {data}
        °C
      </span>
    );
  };

  bleStatus = (data) => {
    if (data === undefined || data === null) {
      return <span>-</span>;
    }
    return <span>{data}</span>;
  };

  timeFormat = (utcFormat) => {
    if (!utcFormat) return "-";
    const dateOutObject = new Date(utcFormat);

    const jam = dateOutObject.getHours();
    const menit = dateOutObject.getMinutes();
    const tanggal = dateOutObject.getDate();
    const bulan = dateOutObject.getMonth() + 1;
    const tahun = dateOutObject.getFullYear();
    return `${jam < 10 ? "0" : ""}${jam}:${
      menit < 10 ? "0" : ""
    }${menit} - ${tanggal}/${bulan}/${tahun}`;
  };

  tempStatusIcon = (data) => {
    if (data > 0)
      return (
        <i
          class="fas fa-thermometer-half card-icon"
          style={{ color: "orange" }}
        ></i>
      );
    return (
      <i
        className="fas fa-snowflake card-icon"
        style={{ color: "darkCyan" }}
      ></i>
    );
  };
  tempStatusColor = (data) => {
    if (data > 0) return "temp-hot";
    return "temp-cold";
  };

  doorStatusIcon = (data, color) => {
    if (data === undefined || data === null) {
      return (
        <i
          className="fas fa-door-closed card-icon"
          style={{ color: color }}
        ></i>
      );
    }
    return data > 0 ? (
      <i className="fas fa-door-open card-icon" style={{ color: color }}></i>
    ) : (
      <i className="fas fa-door-closed card-icon" style={{ color: color }}></i>
    );
  };

  bleStatusIcon = (data) => {
    return data > 0 ? (
      <i className="fas fa-wifi card-icon" style={{ color: "royalBlue" }}></i>
    ) : (
      <React.Fragment>
        <i class="fas fa-wifi card-icon" style={{ color: "royalBlue" }}></i>
        <i class="fas fa-slash card-icon" style={{ color: "royalBlue" }}></i>
      </React.Fragment>
    );
  };

  dataList = () => {
    const monitoringData = this.state.liveMonitoringData[0];
    return (
      <div className="card">
        <div className="card-body">
          <div className="daftar">
            <p>
              <strong>ID Company</strong>
            </p>
            <p>{monitoringData.company || "-"}</p>
          </div>
          <div className="daftar">
            <p>
              <strong>ID Fleet</strong>
            </p>
            {this.clickableIdFleet(monitoringData)}
          </div>
          <div className="daftar">
            <p>
              <strong>Position</strong>
            </p>
            <span>
              {this.latDataFormat(monitoringData)} {this.state.location}
              <i
                className="fas fa-map-marker-alt"
                style={{ marginLeft: 4, color: "red" }}
              ></i>
            </span>
          </div>
          <div className="daftar">
            <p>
              <strong>Timestamp</strong>
            </p>
            <p>
              {this.timeFormat(monitoringData.time)}
              <i
                className="fas fa-clock"
                style={{ marginLeft: 4, color: "darkCyan" }}
              ></i>
            </p>
          </div>
          <div className="daftar">
            <p>
              <strong>Fuel Level</strong>
            </p>
            <p>
              {monitoringData.vsys}
              <i
                className="fas fa-gas-pump"
                style={{ marginLeft: 4, color: "darkGreen" }}
              ></i>
            </p>
          </div>
          <div className="daftar">
            <p>
              <strong>Speed</strong>
            </p>
            <p>
              {monitoringData.spd} km/h
              <i
                className="fas fa-tachometer-alt"
                style={{ marginLeft: 4, color: "darkSlateBlue" }}
              ></i>
            </p>
          </div>
          <div className="daftar">
            <p>
              <strong>Fleet Status</strong>
            </p>
            <p>{this.fleetStatusFormat(monitoringData)}</p>
          </div>
        </div>
      </div>
    );
  };

  cardList = () => {
    const monitoringData = this.state.liveMonitoringData[0];
    return (
      <div className="row">
        <div className="col-md-4">
          <div
            className="card"
            id={this.tempStatusColor(monitoringData.temp_c)}
          >
            {this.tempStatusIcon(monitoringData.temp_c)}
            <div className="card-body">
              <h5 className="card-title">Temperature</h5>
              <p className="card-desc">
                {this.tempStatus(monitoringData.temp_c)}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card" id="left-door">
            {this.doorStatusIcon(monitoringData.door_rear, "darkCyan")}
            <div className="card-body">
              <h5 className="card-title">Left Door Status</h5>
              <p className="card-desc">
                {this.doorStatus(monitoringData.door_left)}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card" id="right-door">
            {this.doorStatusIcon(monitoringData.door_rear, "grey")}
            <div className="card-body">
              <h5 className="card-title">Right Door Status</h5>
              <p className="card-desc">
                {this.doorStatus(monitoringData.door_right)}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card" id="rear-door">
            {this.doorStatusIcon(monitoringData.door_rear, "oliveDrab")}
            <div className="card-body">
              <h5 className="card-title">Rear Door Status</h5>
              <p className="card-desc">
                {this.doorStatus(monitoringData.door_rear)}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card" id="ble">
            {this.bleStatusIcon(monitoringData.ble)}
            <div className="card-body">
              <h5 className="card-title">BLE</h5>
              <p className="card-desc">{this.bleStatus(monitoringData.ble)}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.state.liveMonitoringData.length === 0 ? (
          <center>
            <BarLoader
              color={"#123abc"}
              loading={this.state.liveMonitoringData.length === 0}
            />{" "}
            <br /> Loading.... Please wait...
          </center>
        ) : (
          <React.Fragment>
            {this.dataList()}
            {this.cardList()}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default LiveMonitoringDatatable;



// WEBPACK FOOTER //
// ./src/views/Transporter/LiveTrackerExtn/Datatable.jsx